import { IOfferCard } from '../../../types';
import { getAgentBonusPrice } from './getAgentBonusPrice';
import { getSalePricePerMeter } from './getSalePricePerMeter';

export function getSalePriceInfo(offerCard: IOfferCard, isAgent: boolean): string | undefined {
  const infoParts = [getSalePricePerMeter(offerCard), getAgentBonusPrice(offerCard, isAgent)].filter(Boolean);

  if (infoParts.length > 0) {
    return infoParts.join(', ');
  }

  return undefined;
}
